import types from './mutation-types'

const mutations = {
	[types.SET_ACTIVE_AUCTION](state, auction) {
		state.activeAuction = auction;
	},
    [types.GET_AUCTIONS](state, auctions) {
        state.auctions = auctions;
    },
	[types.FETCH_AUCTION_ITEMS_START](state) {
		state.auctionItems.isFetching = true;
	},
    [types.FETCH_AUCTION_ITEMS](state, payload) {
		state.auctionItems.isFetching = false;
        state.auctionItems.items = payload.items;
        state.auctionItems.meta = payload.meta;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/auction/mutations.js